import invariant from 'invariant';
import PropTypes from 'prop-types';
import cx from "ramda-extension/es/cx";
import React, { Children, cloneElement, Component, createElement, isValidElement } from 'react';
import AngleDown from '../../../atoms/SvgIcon/Icons/AngleDown';
import AngleUp from '../../../atoms/SvgIcon/Icons/AngleUp';
import { withDefaultComponentProps } from '../../../decorators/withDefaultComponentProps';
import ListBoxItem from '../ListBoxItem';
const COMPONENT_NAME = 'ListBoxGroup';
class ListBoxGroup extends Component {
    constructor(props){
        super(props);
        this.state = {
            open: false
        };
    }
    /**
	 * Controlls if any of the children is of 'li' type that is forbidden in this location.
	 * It's presence would cause invalid html document.
	 * The function should return true to not throw an exception in invariant function.
	 */ isSameTypeChildren = (containerElement, children)=>{
        let invariantComponent = true;
        if (children && children.length > 0 && !containerElement) {
            invariantComponent = children.filter((ch)=>ch.props?.containerElement && ch.props.containerElement === 'li') > 0;
        }
        return invariantComponent;
    };
    /**
	 * Propagation of container element to children, when necessary.
	 */ getDecoratedChildrens = (containerElement, children)=>Children.map(children, (child, index)=>{
            const childProps = {
                ...child.props,
                containerElement: containerElement ? containerElement : child.props.containerElement,
                className: cx(child.props.className, {
                    'List--hidden': this.props.expandable && !this.state.open
                }),
                key: index + 1
            };
            return /*#__PURE__*/ cloneElement(child, childProps);
        });
    handleExpanderAction = ()=>{
        this.setState({
            open: !this.state.open
        });
    };
    render() {
        const { closeIcon, openIcon, children, className, containerElement, groupExpanderContent, expandable, noBorder, ...other } = this.props;
        invariant(this.isSameTypeChildren(containerElement, children), 'ListBoxGroup should not have any <li> childrens. Change the children container or remove it.');
        const headerElement = expandable ? /*#__PURE__*/ React.createElement(ListBoxItem, {
            containerElement: "div",
            onClick: this.handleExpanderAction,
            key: 0
        }, groupExpanderContent ? /*#__PURE__*/ React.createElement("div", {
            className: "List-toggleName"
        }, groupExpanderContent) : null, /*#__PURE__*/ React.createElement("span", {
            className: "List-toggle"
        }, this.state.open ? openIcon : closeIcon)) : null;
        const childrens = children ? [
            headerElement
        ].concat(this.getDecoratedChildrens(containerElement, children)) : [
            headerElement
        ];
        const classNames = cx('List-group', {
            'List-group--noBorder': expandable && !this.state.open || noBorder
        }, className);
        const finalContainerElement = containerElement ? containerElement : 'li';
        let itemGroupElement;
        if (/*#__PURE__*/ isValidElement(finalContainerElement)) {
            itemGroupElement = /*#__PURE__*/ cloneElement(finalContainerElement, {
                className: classNames,
                ...other
            }, childrens);
        } else {
            itemGroupElement = /*#__PURE__*/ createElement(finalContainerElement, {
                className: classNames,
                ...other
            }, childrens);
        }
        return itemGroupElement;
    }
}
ListBoxGroup.propTypes = {
    /**
	 * Children will be rendered within the `ListBox`.
	 */ children: PropTypes.node,
    /**
	 * Custom `className` for the root.
	 */ className: PropTypes.string,
    /**
	 * Close icon node
	 */ closeIcon: PropTypes.node,
    /**
	 * Specifies container element of list group and it`s items. Could be 'div' or 'span'.
	 */ containerElement: PropTypes.node,
    /**
	 * If true, the element will show expander icon.
	 */ expandable: PropTypes.bool,
    /**
	 * If specified the expander element will have content node.
	 *  In order to show `groupExpanderContent` the `expander` property must be true.
	 */ groupExpanderContent: PropTypes.node,
    /**
	 * If true, the element will have no border.
	 */ noBorder: PropTypes.bool,
    /**
	 * Open icon node
	 */ openIcon: PropTypes.node
};
export { ListBoxGroup };
export default withDefaultComponentProps(COMPONENT_NAME, {
    expandable: false,
    noBorder: false,
    openIcon: /*#__PURE__*/ React.createElement(AngleUp, null),
    closeIcon: /*#__PURE__*/ React.createElement(AngleDown, null)
}, ListBoxGroup);
